import { useCallback } from 'react'
import { useMailStore } from '../stores/mailStore'
import { useAccountStore } from '../stores/accountStore'
import { mailboxesToLabels } from '../lib/jmapAdapter'

/**
 * Returns a `markThreadRead(threadId, isRead)` callback that:
 * 1. Optimistically updates local state so the UI reflects the change instantly.
 * 2. Persists the change to Stalwart via JMAP setKeyword ($seen).
 * 3. Re-fetches mailboxes so sidebar unread counters update immediately.
 */
export function useMarkThreadRead() {
  const { markRead } = useMailStore()

  return useCallback((threadId: string, isRead: boolean) => {
    // 1. Optimistic local update
    markRead(threadId, isRead)

    // 2. Persist via JMAP — set/unset $seen on all emails in the thread
    const client = useAccountStore.getState().getActiveClient()
    if (!client) return

    client.setThreadKeyword(threadId, '$seen', isRead)
      .then(() => client.listMailboxes())
      .then((updatedMailboxes) => {
        // 3. Refresh mailbox unread counts in accountStore + sidebar labels
        useAccountStore.getState().updateAccount(client.accountEmail, { mailboxes: updatedMailboxes })
        useMailStore.setState({ labels: mailboxesToLabels(updatedMailboxes) })
      })
      .catch(() => {})
  }, [markRead])
}
